import { l as e, n as t, t as n } from "./gallery-preview-carousel-Col7B2hH.js";
import { computed as r, createBlock as i, createCommentVNode as a, createElementBlock as o, createElementVNode as s, createTextVNode as c, createVNode as l, defineAsyncComponent as u, defineComponent as d, normalizeClass as f, onBeforeMount as p, openBlock as m, ref as h, toDisplayString as g, unref as _, watch as v, withCtx as y } from "vue";
import { quasarValidateRules as b } from "@editor/ui-utils";
import { QBtn as x, QCard as S, QCardSection as C, QDialog as w, QIcon as T, useFormChild as E } from "quasar";
import { stateChangeIn as D } from "@modules/image-editor-ui-components";
import { useI18n as O } from "vue-i18n";
import { StatusIcon as k } from "@editor/ui-layout";
//#region src/lib/events.ts
var A = "onGalleryUpdated", j = class extends CustomEvent {
	constructor(e) {
		super(A, { detail: e });
	}
}, M = {
	key: 0,
	class: "gallery-overlay absolute-full flex flex-center"
}, N = { class: "relative-center text-subtitle2 gallery-overlay-label text-dark" }, P = /* @__PURE__ */ t(/* @__PURE__ */ d({
	__name: "gallery-state-overlay",
	props: { gallery: {} },
	setup(e) {
		let { t } = O(), n = e, i = r(() => D(n.gallery.publishDate)), u = r(() => D(n.gallery.unpublishDate)), d = {
			draft: {
				icon: "edit-3",
				text: "states.galleryDraft",
				color: "text-grey"
			},
			schedule: {
				icon: "clock",
				text: "states.galleryPublish",
				color: "text-light-blue"
			},
			unpublish: {
				icon: "alert-circle",
				text: "states.galleryExpired",
				color: "text-red"
			},
			publish: {
				icon: "clock",
				text: "states.galleryExpiresIn",
				color: "text-red"
			}
		}, p = r(() => d[n.gallery.state]);
		return (e, r) => n.gallery.state !== "publish" || n.gallery.state === "publish" && n.gallery.unpublishDate ? (m(), o("div", M, [s("div", N, [l(_(k), {
			value: p.value?.icon,
			class: f(["gallery-overlay-icon", p.value.color])
		}, null, 8, ["value", "class"]), c(" " + g(_(t)(p.value?.text, { n: n.gallery.state === "publish" ? u.value : i.value })), 1)])])) : a("", !0);
	}
}), [["__scopeId", "data-v-e8f19770"]]), F = { class: "row justify-center items-center align-center text-center" }, I = { class: "col-6" }, L = {
	key: 0,
	class: "required"
}, R = { class: "gallery--wrapper" }, z = { class: "gallery--description" }, B = { class: "q-mx-md" }, V = { class: "text-wrap q-mb-xs q-mt-sm" }, H = { class: "q-field__messages text-negative col" }, U = ["textContent"], W = /* @__PURE__ */ t(/* @__PURE__ */ d({
	__name: "gallery-list.selector",
	props: {
		modelValue: { default: void 0 },
		rules: { default: void 0 },
		state: { default: void 0 },
		license: { default: void 0 },
		width: { default: "100" },
		height: { default: "100" },
		required: {
			type: Boolean,
			default: !1
		},
		disableBrandFilter: { type: Boolean },
		showPartnerGalleries: {
			type: Boolean,
			default: !1
		},
		previewOffset: { default: 0 },
		previewLimit: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue", "update:gallery"],
	setup(t, { emit: d }) {
		let D = u(() => import("./gallery-edit-rvMEELrv.js")), k = u(() => import("./gallery-list-BgzVi6ma.js")), A = t, j = d, M = () => ({
			_id: "",
			bfJobUuid: "",
			title: "",
			isDeleted: !1,
			isPartnerGallery: !1,
			createDate: /* @__PURE__ */ new Date(),
			changeDate: /* @__PURE__ */ new Date(),
			state: "draft",
			adsEnabled: !1,
			references: [],
			type: "GALLERY",
			brand: void 0,
			legacy: {
				source: "vibe",
				isEditableInCTF: !0,
				isRenderedByCTF: !0,
				hasBeenModifiedInCTF: !0
			},
			authorUuids: [],
			seoTitle: "",
			feeds: {
				msnAt: "exclude",
				msnCh: "exclude",
				msnDe: "exclude"
			},
			paths: []
		}), { t: N } = O(), W = h(!1), G = h(!1), K = h(!0), q = h(M()), J = h(""), Y = h(), X = parseInt(A?.width, 10), Z = parseInt(A?.height, 10), Q = r(() => !A.disable && (G.value || W.value)), $ = () => {
			let e = b(q.value, A.rules);
			K.value = !e, J.value = e;
		};
		E({
			validate() {
				return $(), K.value || Y.value?.scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "center"
				}), K.value;
			},
			resetValidation() {
				K.value = !0;
			}
		});
		let ee = (e) => {
			q.value = e, W.value = !1, $(), j("update:modelValue", q.value._id), j("update:gallery", e);
		}, te = () => {
			A.disable || (q.value = M(), j("update:modelValue"));
		}, ne = () => {
			G.value = !0, W.value = !1;
		}, re = (e) => {
			if (!e) return;
			let t = q.value?.state !== "publish" && e.state === "publish";
			q.value = e, j("update:modelValue", e._id), j("update:gallery", e), $(), t && (G.value = !1);
		};
		return p(async () => {
			A.modelValue && (q.value = await e(A.modelValue));
		}), v(() => A.modelValue, async () => {
			A.modelValue ? q.value = await e(A.modelValue) : q.value = M(), J.value = "";
		}), (e, r) => (m(), o("div", {
			ref_key: "wrapper",
			ref: Y
		}, [l(_(S), {
			flat: "",
			class: f({ invalid: !K.value })
		}, {
			default: y(() => [t.modelValue ? (m(), i(_(C), {
				key: 1,
				class: "q-pa-none"
			}, {
				default: y(() => [s("div", R, [
					l(n, {
						references: q.value.references,
						"data-qa-gallery-preview-carousel": "",
						"preview-size": {
							width: _(X),
							height: _(Z)
						},
						"preview-offset": t.previewOffset,
						"preview-limit": t.previewLimit
					}, null, 8, [
						"references",
						"preview-size",
						"preview-offset",
						"preview-limit"
					]),
					l(P, { gallery: q.value }, null, 8, ["gallery"]),
					s("div", z, [s("div", B, [
						s("div", V, g(q.value.title), 1),
						t.disable ? a("", !0) : (m(), i(_(x), {
							key: 0,
							"data-qa-gallery-picker-edit-button": "",
							outline: "",
							color: "white",
							"text-color": "black",
							label: _(N)("galleryList.edit"),
							class: "border-btn q-mr-sm",
							onClick: r[1] ||= (e) => G.value = !0
						}, null, 8, ["label"])),
						t.disable ? a("", !0) : (m(), i(_(x), {
							key: 1,
							"data-qa-gallery-picker-remove-button": "",
							outline: "",
							color: "white",
							"text-color": "black",
							label: _(N)("galleryList.remove"),
							class: "border-btn",
							onClick: te
						}, null, 8, ["label"]))
					])])
				])]),
				_: 1
			})) : (m(), i(_(C), {
				key: 0,
				style: { height: "100%" },
				"data-qa-gallery-picker": "",
				class: "border-item border-item--dashed",
				onClick: r[0] ||= (e) => W.value = !0
			}, {
				default: y(() => [s("div", F, [s("div", I, [l(_(T), {
					size: "36px",
					name: "gallery",
					color: "grey-5"
				}), l(_(C), {
					flat: "",
					color: "white"
				}, {
					default: y(() => [c(g(_(N)("galleryList.galleryLabel")) + " ", 1), t.required ? (m(), o("span", L)) : a("", !0)]),
					_: 1
				})])])]),
				_: 1
			})), J.value ? (m(), i(_(C), {
				key: 2,
				class: "q-field__bottom row items-start q-field__bottom--animated"
			}, {
				default: y(() => [s("div", H, [s("div", {
					role: "alert",
					textContent: g(J.value)
				}, null, 8, U)])]),
				_: 1
			})) : a("", !0)]),
			_: 1
		}, 8, ["class"]), l(_(w), {
			modelValue: Q.value,
			"onUpdate:modelValue": r[6] ||= (e) => Q.value = e,
			"allow-focus-outside": "",
			"data-qa-edit-gallery-dialog": "",
			"full-width": "",
			"full-height": "",
			container: ""
		}, {
			default: y(() => [G.value ? (m(), i(_(D), {
				key: 0,
				id: t.modelValue,
				dialog: !0,
				title: t.modelValue ? _(N)("gallery.router.editGallery") : _(N)("gallery.router.createGallery"),
				"back-route": void 0,
				onClose: r[2] ||= (e) => G.value = !1,
				"onBack:modal": r[3] ||= (e) => G.value = !1,
				onSaveGallery: re
			}, null, 8, ["id", "title"])) : W.value ? (m(), i(_(k), {
				key: 1,
				dialog: !0,
				state: t.state,
				brand: t.license,
				"disable-brand-filter": t.disableBrandFilter,
				"show-partner-galleries": t.showPartnerGalleries,
				"onClick:gallery": ee,
				onClose: r[4] ||= (e) => W.value = !1,
				"onClick:gallery:new": r[5] ||= (e) => ne()
			}, null, 8, [
				"state",
				"brand",
				"disable-brand-filter",
				"show-partner-galleries"
			])) : a("", !0)]),
			_: 1
		}, 8, ["modelValue"])], 512));
	}
}), [["__scopeId", "data-v-9a694930"]]);
//#endregion
export { j as n, A as r, W as t };

//# sourceMappingURL=gallery-list.selector-t3NALU34.js.map